<div
    #chartElement
    class="agpr-briefing-chart"
></div>
<agpr-twig
    [id]="id + '_twig'"
    class="agpr-briefing-twig"
    [agprLoading]="loading"
    [loadingSmallIndicator]="smallIndicator"
    [twigTemplate]="block.type.twig"
    [data]="twigData"
    [generateOnSend]="generateOnSend"
    (renderedOutput)="setRenderedOutput($event)"
></agpr-twig>
